export const blockIconsBusinessandpaymentsStoreNew = (
	<span className='material-symbols-outlined'>store</span>
);
